import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  fetchCoinSettlementsApi,
  addCoinSettlementApi,
  updateCoinSettlementApi,
  deleteCoinSettlementApi,
} from "./coinSettlementsApi";

const getErrorMessage = (error, defaultMsg) => {
  if (error.response?.data) {
    const data = error.response.data;
    if (typeof data === "string") return data;
    return data.ExceptionMessage || data.message || data.title || defaultMsg;
  }
  return "Bağlantı hatası";
};

export const fetchCoinSettlements = createAsyncThunk(
  "coinSettlements/fetch",
  async ({ branchId, transactionDate }, { rejectWithValue }) => {
    try {
      const data = await fetchCoinSettlementsApi(branchId, transactionDate);
      return data.items || [];
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Bozuk para alımları alınamadı."));
    }
  }
);

export const addCoinSettlement = createAsyncThunk(
  "coinSettlements/add",
  async (settlement, { rejectWithValue }) => {
    try {
      const data = await addCoinSettlementApi(settlement);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Bozuk para alımı eklenemedi."));
    }
  }
);

export const updateCoinSettlement = createAsyncThunk(
  "coinSettlements/update",
  async ({ id, settlement }, { rejectWithValue }) => {
    try {
      const data = await updateCoinSettlementApi(id, settlement);
      return data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Bozuk para alımı güncellenemedi."));
    }
  }
);

export const deleteCoinSettlement = createAsyncThunk(
  "coinSettlements/delete",
  async (id, { rejectWithValue }) => {
    try {
      await deleteCoinSettlementApi(id);
      return id;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, "Bozuk para alımı silinemedi."));
    }
  }
);
